import { LayoutDataType } from '../../types';

export const INTERACTION_OPTIONS: {
  id: LayoutDataType['interaction'];
  title: string;
}[] = [
  {
    id: 'relationships',
    title: '💖 Sustainable relationships',
  },
  {
    id: 'friendship',
    title: '✌️ Friendship',
  },
  {
    id: 'keep_in_touch',
    title: '💬 Just keep in touch',
  },
  {
    id: 'one_night_stand',
    title: '💦 One night stand',
  },
];
